/** @format */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { AiOutlineSearch } from "react-icons/ai";

import {
  ActionIcon,
  Badge,
  Button,
  Input,
  Pagination,
  Select,
  Skeleton,
  Table,
  Text,
  CloseButton,
  TextInput,
  Anchor,
  Modal,
} from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { DatePicker } from "@mantine/dates";
import {
  Eye,
  History,
  Plus,
  Search,
  SortAscending,
  SortDescending,
} from "tabler-icons-react";
import { formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import {
  deleteAgreementBulk,
  getAgreementsInReviewCsvDownload,
} from "../../utilities/apis/agreements";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
  formatIndianNumber,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementsList,
  getAgreementTypesApi,
  getAgreementsCsvDownload,
} from "../../utilities/apis/agreements";
import UserAvatarView from "../../components/UserAvatarView";
import DashboardNotifications from "../DashboardNotifications";
import { agreementStatusColors } from "../../utilities/enums";
import AgreementAnalytics1 from "../../components/AgreementAnalytics/AgreementAnalytics1";
import colors, { themeColor } from "../../utilities/design";
import AgreementGraph from "./AgreementGraph";
import Styles from "./AgreementsListingPage.module.css";
import { INDIA_STATES_UNIONS } from "./AgreementForm2";
import HamburgerMenu from "../HamburgerMenuAgreements";
import HamburgerMenuAgreements from "../HamburgerMenuAgreements";
import Collaboration from "./../../components/Collaboration/Collaboration";
import AgreementGraph2 from "./AgreementGraph2";
import { getAgreementsInReviewList } from "../../utilities/apis/agreements";
import RelatedAgreementModal from "./agreementRelatedModal";
import AgreementAuditLogModal from "./AgreementAuditLogModal";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/selectors";
import { IconArrowDownBar, IconArrowUpBar } from "@tabler/icons-react";
import UniversalTable from "../../components/Common/UniversalTable";
import TablePagination from "../../components/Common/TablePagination";

const statusOptions = [
  {
    label: "Pending with Company",
    value: "Pending with Company",
  },
  {
    label: "TP",
    value: "TP",
  },
];

const estampOption = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

const AgreementsInCollabrationListingPage = () => {
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [listing, setListing] = useState({
    list: null,
    agreementsCount: null,
    loaded: false,
    sortBy: "createdAt",
    sortDirection: "desc",
    searchString: "",
    statusType: "",
    estamp: null,
    agreementType: null,
    location: null,
    startDate: null,
    endDate: null,
  });
  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  const [uiConfigs, setUiConfigs] = useState({
    loading: loadingStates.NO_ACTIVE_REQUEST,
    page: 1,
  });
  const [debouncedSearchInput] = useDebouncedValue(listing.searchString, 500);
  const [agreementPayload, setAgreementPayload] = useState({});
  const [exportButtonLoading, setExportButtonLoading] = useState(false);
  const [range, setRange] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [relatedAgreementId, setRelatedAgreementId] = useState(null);
  const currentUser = useSelector(selectUserData);
  const handleCheckboxChange = (id, isChecked) => {
    setSelectedIds((prevSelectedIds) => {
      if (isChecked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };

  const handlePlusClick = (id) => {
    setShowModalRelated(true);
    setRelatedAgreementId(id);
  };

  const deleteHandler = async () => {
    console.log("Deleting agreements with IDs:", selectedIds);
    const agreementIds = selectedIds;
    setDeleteLoading(true);
    const response = await apiWrapWithErrorWithData(
      deleteAgreementBulk({ agreementIds })
    );
    if (response?.success) {
      showNotification({
        color: "green",
        title: "Agreements",
        message: "Agreement deleted successfully.",
      });
      setOpen(false);
      navigate("/app");
    } else {
      showNotification({
        color: "red",
        title: "Agreements",
        message: "Unable to delete agreement",
      });
    }
    setDeleteLoading(false);
  };

  const fetchAgreementsList = async ({ page }) => {
    let filterOptions = {};
    if (listing.startDate && listing.endDate) {
      filterOptions["createdAt"] = {
        gte: formatISO(listing.startDate),
        lte: formatISO(listing.endDate),
      };
    } else if (listing.startDate || listing.endDate) {
      showNotification({
        title: "Agreement notification",
        message: "please select start and end date",
        color: "red",
      });
      return;
    }
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.LOADING,
    });
    const payload = {
      page: page ? page : uiConfigs.page,
      sortByOptions: {
        [listing.sortBy]: listing.sortDirection,
      },
      pageSize,
    };
    if (listing.agreementType && listing.statusType && listing.estamp) {
      filterOptions = {
        ...filterOptions,
        typeOfAgreement: {
          equals: listing.agreementType,
        },
        status: {
          equals: listing.statusType,
        },
        agreementType: {
          equals: listing.estamp === "Yes" ? "eStamp" : "normal",
        },
      };
    } else if (listing.agreementType || listing.statusType || listing.estamp) {
      if (listing.agreementType) {
        filterOptions["typeOfAgreement"] = {
          equals: listing.agreementType,
        };
      }
      if (listing.statusType) {
        filterOptions["status"] = {
          equals: listing.statusType,
        };
      }
      if (listing.estamp) {
        filterOptions["agreementType"] = {
          equals: listing.estamp === "Yes" ? "eStamp" : "normal",
        };
      }
    }
    if (listing.location) {
      filterOptions["location"] = listing.location;
    }

    payload["filterOptions"] = filterOptions;

    setAgreementPayload(payload);
    const response = await apiWrapWithErrorWithData(
      getAgreementsList({ ...payload })
    );
    if (response?.success && response?.agreements) {
      setListing({
        ...listing,
        list: response?.agreements,
        agreementsCount: response.agreementsCount,
        loaded: true,
      });
    }
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.NO_ACTIVE_REQUEST,
    });
  };
  const data = listing?.list;

  // useEffect(() => {
  //   getAgreementTypes();
  // }, []);

  // useEffect(() => {
  //   if (listing.agreementType || listing.statusType || listing.estamp) {
  //     fetchAgreementsList({ page: 1 });
  //     setUiConfigs((prevState) => ({
  //       ...prevState,
  //       page: 1,
  //     }));
  //   } else if (listing.estamp) {
  //     fetchAgreementsList({ page: 1 });
  //     setUiConfigs((prevState) => ({
  //       ...prevState,
  //       page: 1,
  //     }));
  //   } else if (listing.startDate && listing.endDate) {
  //     fetchAgreementsList({ page: 1 });
  //     setUiConfigs((prevState) => ({
  //       ...prevState,
  //       page: 1,
  //     }));
  //   } else {
  //     if (listing.startDate === null && listing.endDate === null) {
  //       fetchAgreementsList({});
  //     }
  //   }
  // }, [listing.sortBy, listing.sortDirection]);

  // useEffect(() => {
  //   fetchAgreementsList({});
  // }, [uiConfigs.page, pageSize]);

  const navigate = useNavigate();
  const onViewClick = (agreementId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementId}`;
    window.open(url, '_blank'); // '_blank' specifically tells the browser to open in a new tab/window
};

  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
      const temp = uniqueValues.map((item) => ({ label: item, value: item }));
      setAgreementTypeOptions([...agreementTypeOptions, ...temp]);
    }
  };
  const handleCsvDownload = async () => {
    try {
      setExportButtonLoading(true);
      const response = await apiWrapWithErrorWithData(
        getAgreementsInReviewCsvDownload({ ...agreementPayload })
      );
      if (response.success) {
        if (response?.agreements.length > 0) {
          const columnHeaders = Object.keys(response.agreements[0]);
          csvDownload({
            data: response.agreements,
            headers: columnHeaders,
            name: "agreement in collaboration",
          });
        } else {
          showNotification({
            title: "Agreement csv download",
            message: "No agreement available",
            color: "red",
          });
        }
      }
      setExportButtonLoading(false);
    } catch (error) {
      setExportButtonLoading(false);
      showNotification({
        title: "Agreement csv download",
        message: "Could not load agreement csv",
        color: "red",
      });
    }
  };

  const clearHandler = async () => {
    try {
      setUiConfigs({
        ...uiConfigs,
        page: 1,
        loading: loadingStates.LOADING,
      });

      const payload = {
        page: 1,
        sortByOptions: {
          [listing.sortBy]: listing.sortDirection,
        },
        filterOptions: {},
        pageSize,
      };

      setAgreementPayload(payload);
      const response = await apiWrapWithErrorWithData(
        getAgreementsList({ ...payload })
      );

      if (response?.success && response?.agreements) {
        setListing({
          ...listing,
          searchString: "",
          agreementType: "",
          statusType: null,
          estamp: "",
          location: null,
          startDate: null,
          endDate: null,
          list: response?.agreements,
          agreementsCount: response.agreementsCount,
          loaded: true,
          estamp: null,
        });
      }

      setUiConfigs({
        ...uiConfigs,
        loading: loadingStates.NO_ACTIVE_REQUEST,
      });
    } catch (error) {
      console.log("Agreement list fetching error: ", error);
    }
  };
  const [sortByOptions, setSortByOptions] = useState({
    key: "createdAt",
    value: "desc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };
  const [reviewAgreementpage, setReviewAgreementpage] = useState(1);
  let serialNumber = (reviewAgreementpage - 1) * pageSize + 1;
  const [filters, setFilter] = useState({
    typeOfAgreement: null,
    mapBusinessunit: null,
    mapRegion: null,
  });
  const [configs, setConfigs] = useState({
    loading: loadingStates.LOADING,
    data: null,
  });
  const [showModal, setShowModal] = useState(false);
  const [agreementId, setAgreementId] = useState(null);
  const handleSearchClick = (id) => {
    // Set the showModal state to true when the button is clicked
    setShowModal(true);
    // Pass the row id to the AgreementAuditLogModal component
    setAgreementId(id);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const filtersForData = await Object.fromEntries(
          Object.entries(filters).filter(([key, value]) => value !== null)
        );
        const sortOption = { [sortByOptions.key]: sortByOptions.value };
        const response = await apiWrapWithErrorWithData(
          getAgreementsInReviewList({
            page: reviewAgreementpage,
            pageSize: pageSize,
            filterOptions: filtersForData,
            sortByOptions: sortOption,
            range: range,
          })
        );
        if (response) {
          setConfigs({
            loading: loadingStates.NO_ACTIVE_REQUEST,
            data: response,
          });
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
    fetchData();
  }, [reviewAgreementpage, pageSize, filters, sortByOptions, range]);
  
    const subTextStyle = {
      fontSize: "10px",
      fontWeight: 400,
      opacity: 0.7,
      lineHeight: 1.2,
    };

    const formatDate = (dateString) => {
      if (!dateString) return "--";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
    };

    const tableHeaders = [
      {
        // CIN / Job Order
        label: (
          <div>
            <div>CIN</div>
            <div style={subTextStyle}>JOB ORDER</div>
          </div>
        ),
        render: (row) => (
          <div className="flex flex-col">
            <Text size="xs" weight={600} color="#2089ae">{`#${row.id}`}</Text>
            <Text size="10px" color="dimmed">
              {row.jobOrder || "NO JO"}
            </Text>
          </div>
        ),
      },
      {
        // Category / BU
        label: (
          <div>
            <div>Category</div>
            <div style={subTextStyle}>BU</div>
          </div>
        ),
        render: (row) => (
          <div className="flex flex-col">
            <Text size="xs" weight={500}>
              {row.agreementData?.json?.typeOfAgreement || "--"}
            </Text>
            <Text size="10px" color="dimmed">
              {row?.businessUnit || "--"}
            </Text>
          </div>
        ),
      },
      {
        label: "ACV (INR)",
        render: (row) => (
          <Text size="xs" weight={700}>
            {formatIndianNumber(row.agreementValue)}
          </Text>
        ),
      },
      {
        // Brand Name / Second Party
        label: (
          <div>
            <div>Brand Name</div>
            <div style={subTextStyle}>SECOND PARTY</div>
          </div>
        ),
        render: (row) => (
          <div className="flex flex-col" style={{ maxWidth: "10px" }}>
            <Text
              size="xs"
              weight={500}
              truncate
              title={row.agreementData?.json?.brandName}
            >
              {row.agreementData?.json?.brandName || "N/A"}
            </Text>
            <Text
              size="10px"
              color="dimmed"
              truncate
              title={row.agreementData?.json?.secondParty}
            >
              {row.agreementData?.json?.secondParty || "--"}
            </Text>
          </div>
        ),
      },
      {
    // Pending With Header
    label: (
      <div>
        <div>Pending With</div>
        {/* <div style={subTextStyle}>CURRENT ASSIGNEE</div> */}
      </div>
    ),
    render: (row) => (
      <Text size="xs" weight={500}>
        {row.pendingWith || "--"}
      </Text>
    ),
  },
  {
    // Ageing Header
    label: (
      <div>
        <div>Ageing</div>
      </div>
    ),
    render: (row) => {
      let ageingColor;
      if (row.ageing <= 7) ageingColor = "rgb(70, 189, 225)";
      else if (row.ageing <= 10) ageingColor = "#FDAE38";
      else ageingColor = "#F75435";

      return (
        <Text size="xs" weight={700} style={{ color: ageingColor }}>
          {row.ageing}
        </Text>
      );
    },
  },
  {
    // Actions Header
    label: (
      <div style={{ textAlign: "right" }}>
        <div>Actions</div>
      </div>
    ),
    align: "right",
    render: (row) => (
      <div className="flex flex-row justify-end items-center gap-1">
        {row.relationshipWith ? (
          <ActionIcon onClick={() => handlePlusClick(row.id)}>
            <Plus color="#1b6f8d" size={20} />
          </ActionIcon>
        ) : (
          <div className="w-8 flex justify-center text-gray-400">--</div>
        )}

        <ActionIcon onClick={() => onViewClick(row.id)}>
          <Eye color="#1b6f8d" size={20} />
        </ActionIcon>

        <ActionIcon onClick={() => handleSearchClick(row.id)}>
          <History color="#1b6f8d" size={20} />
        </ActionIcon>
      </div>
    ),
  },
    ];

  return (
    <>
      <Modal
        overflow="inside"
        opened={showModalRelated}
        onClose={() => {
          setShowModalRelated(false);
        }} // Call the handler on modal close
        size="calc(80vw)"
      >
        <RelatedAgreementModal agreementId={relatedAgreementId} />
      </Modal>
      <Modal
        overflow="inside"
        opened={showModal}
        onClose={() => setShowModal(false)} // Call the handler on modal close
        size="calc(80vw)"
      >
        <AgreementAuditLogModal agreementId={agreementId} />
      </Modal>
      <div
        className="flex"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <h1
          style={{
            fontSize: "22px",
            fontWeight: "600",
            letterSpacing: "1px",
            fontFamily: "Lato",
            whiteSpace: "nowrap",
            paddingBottom: "13px",
            position: "relative",
            color: "#5F6464",
            // margin: "0 auto"
          }}
        >
          Review in Progress
        </h1>
        <HamburgerMenuAgreements />
        <div className="fixed top-2 right-0 z-50 w-16"></div>
      </div>
      <div className="flex flex-row flex-wrap w-full">
        <AgreementAnalytics1
          filters={filters}
          setFilter={setFilter}
          configs={configs}
          setRange={setRange}
        />
      </div>
      <AgreementGraph2 configs={configs} />
      {(currentUser.loginAs.id === 4 ||
        currentUser.loginAs.id === 2 ||
        currentUser.loginAs.id === 1) && (
        <>
          <div className="flex flex-col">
            <div className="flex justify-between my-4">
              <Text>table view</Text>
              <div className="flex float-right">
                <div className="flex">
                  <Select
                    value={sortByOptions.key}
                    onChange={(val) => handleKeyChange(val)}
                    data={[
                      { label: "created at", value: "createdAt" },
                      { label: "end date", value: "dueDateOfContract" },
                      { label: "type of agreement", value: "typeOfAgreement" },
                      { label: "ain", value: "id" },
                      { label: "agreeement value", value: "agreementValue" },
                    ]}
                  />

                  <ActionIcon className="mx-2" onClick={toggleOrder}>
                    {sortByOptions.value === "asc" ? (
                      <SortAscending size={32} />
                    ) : (
                      <SortDescending size={32} />
                    )}
                  </ActionIcon>
                </div>
                <Button
                  className="mx-2 btn btn-success btn-lg float-right"
                  disabled={exportButtonLoading}
                  onClick={handleCsvDownload}
                  style={{
                    backgroundColor: "#1b6f8d",
                  }}
                >
                  Export
                </Button>
              </div>
            </div>
          </div>
          {configs.loading === loadingStates.LOADING && (
            <div className="flex flex-col">
              {Array.from({ length: 10 }).map((i) => (
                <Skeleton
                  key={i}
                  height={30}
                  radius="md"
                  className="my-1 w-full"
                />
              ))}
              <div className="flex flex-row justify-center">
                <Skeleton height={40} radius="md" className="w-40" />
              </div>
            </div>
          )}

          {configs.data && configs.data?.agreements?.length > 0 ? (
            <>
              <UniversalTable
                headers={tableHeaders}
                data={configs.data.agreements}
                loading={configs.loading === loadingStates.LOADING}
              />

              <TablePagination
                totalCount={configs.data.agreementsCount} 
                page={reviewAgreementpage} 
                pageSize={pageSize} 
                dataLength={configs.data.agreements.length}
                onPageChange={(page) => setReviewAgreementpage(page)}
                onPageSizeChange={(s) => {
                  setPageSize(parseInt(s));
                  setReviewAgreementpage(1); // Reset to page 1 on size change
                }}
              />
            </>
          ) : (
            <div
              className="flex justify-center items-center text-gray-500"
              style={{ minHeight: "300px" }}
            >
              No agreements found
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AgreementsInCollabrationListingPage;
